import { render, staticRenderFns } from "./contentPage.vue?vue&type=template&id=4f3319fe&scoped=true"
import script from "./contentPage.vue?vue&type=script&lang=js"
export * from "./contentPage.vue?vue&type=script&lang=js"
import style0 from "./contentPage.vue?vue&type=style&index=0&id=4f3319fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3319fe",
  null
  
)

export default component.exports